import React, { Component } from 'react';
import { connect } from 'react-redux';
import { ConversationPreview } from 'elements';
import { getConversations, clearConversations } from 'actions/conversations';
import InfiniteScroll from 'react-infinite-scroller';
import CN from 'classnames';
import { withRouter } from 'react-router-dom';
import { showRecipientEmailForNonSuperUser } from 'configuration';
import { ADMIN_ROLES } from 'layouts/partials/header/Header';
import PropTypes from 'prop-types';
import { initialPagination } from 'reducers/conversations';

import './ConversationsPage.css';


function mapState(state) {
  return {
    ...state.conversations,
    ownUUID: state.auth.user ? state.auth.user.uuid : null,
    superuser: state.auth.suAccessToken,
    admin: state.auth.admin
  };
}

function mapDispatch(dispatch, props) {
  return {
    getConversations(pagination, filter) {
      return getConversations(dispatch, props.history, pagination, filter);
    },
    clearConversations() {
      return clearConversations(dispatch, props.history);
    }
  };
}

export const conversationPageType = {
  empty: 'empty',
  free: 'free',
  paid: 'paid',
  unanswered24h: 'unanswered24h'
};

class ConversationsPage extends Component {

  static propTypes = {
    ownUUID: PropTypes.string,
    superuser: PropTypes.string,
    pt: PropTypes.string,
    admin: PropTypes.object,
    history: PropTypes.object,
    conversations: PropTypes.array,
    pagination: PropTypes.object,
    getConversations: PropTypes.func,
    clearConversations: PropTypes.func
  };

  componentWillMount() {
    const { pagination, pt } = this.props;
    this.props.getConversations(pagination, pt);
  }

  componentWillReceiveProps(nextProps) {
    const { pt, clearConversations, getConversations } = this.props;
    if (nextProps.pt !== pt) {
      clearConversations();
      getConversations(initialPagination, nextProps.pt);
    }
  }

  handleLoadMore(page) {
    const { pagination, pt } = this.props;
    this.props.getConversations({ ...pagination, current: page }, pt);
  }

  hasMore() {
    const { total, current, pageSize } = this.props.pagination;
    return total > ((current + 1) * pageSize);
  }

  displayEmail() {
    if (this.props.superuser && (this.props.admin.role === ADMIN_ROLES.SUPERUSER)) {
      return true;
    } else {
      return showRecipientEmailForNonSuperUser;
    }
  }

  render() {
    const { total, current } = this.props.pagination;
    const { conversations, pt } = this.props;
    return (
      <div className="p-20">
        <div
          className={ CN({
            'conversations-list-empty': pt === conversationPageType.empty,
            'conversations-list': pt !== conversationPageType.empty
          }) }
        >
          { (total === 0 && current === 0) && `No ${ pt } conversations found for this Psychic.` }
          <InfiniteScroll
            pageStart={ 0 }
            initialLoad={ false }
            loadMore={ ::this.handleLoadMore }
            hasMore={ ::this.hasMore() }
            useWindow={ false }
            loader={ <div className="loader" key={ 0 }>Loading ...</div> }
          >
            { conversations.map(c => {
              c.participants.forEach(p => {
                if (p.uuid !== this.props.ownUUID) {
                  c.participant = p;
                }
              });
              return <ConversationPreview
                key={ c.uuid }
                conversation={ c }
                displayEmail={ this.displayEmail() }
                history={ this.props.history }
              />;
            })
            }
          </InfiniteScroll>
        </div>
      </div>
    );
  }
}

export default withRouter(connect(mapState, mapDispatch)(ConversationsPage));



// WEBPACK FOOTER //
// ./src/pages/conversations/ConversationsPage.jsx